/* eslint-disable */
/* tslint:disable */

import {
	PermissionCreateRequest,
	RoleCreateRequest,
	RolePermissionsEditRequest,
	RoleResponse,
	RolesList,
	String,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

class Role<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
	/**
	 * No description
	 *
	 * @tags Роли
	 * @summary Создание роли
	 * @request POST:/role
	 * @secure
	 */
	roleCreate = (data: RoleCreateRequest, params: RequestParams = {}) =>
		this.request<RoleResponse, void | String[]>({
			path: `/role`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Роли
	 * @summary Получение списка ролей
	 * @request GET:/role/list
	 * @secure
	 */
	listList = (
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<RolesList, void>({
			path: `/role/list`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Роли
	 * @summary Редактирование роли
	 * @request PUT:/role/{id}
	 * @secure
	 */
	roleUpdate = (id: number, data: RoleCreateRequest, params: RequestParams = {}) =>
		this.request<RoleResponse, void | String[]>({
			path: `/role/${id}`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Роли
	 * @summary Удаление роли
	 * @request DELETE:/role/{id}
	 * @secure
	 */
	roleDelete = (id: number, params: RequestParams = {}) =>
		this.request<RoleResponse, void>({
			path: `/role/${id}`,
			method: "DELETE",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Роли
	 * @summary Список прав роли
	 * @request GET:/role/{id}/permissions
	 * @secure
	 */
	permissionsDetail = (id: number, params: RequestParams = {}) =>
		this.request<String[], void>({
			path: `/role/${id}/permissions`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Роли
	 * @summary Редактирование прав роли
	 * @request PUT:/role/{id}/permissions
	 * @secure
	 */
	permissionsUpdate = (id: number, data: RolePermissionsEditRequest, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/role/${id}/permissions`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.Json,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Роли
	 * @summary Создание права доступа
	 * @request POST:/role/permission
	 * @secure
	 */
	permissionCreate = (data: PermissionCreateRequest, params: RequestParams = {}) =>
		this.request<RoleResponse, void | String[]>({
			path: `/role/permission`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Роли
	 * @summary Список прав доступа
	 * @request GET:/role/permission/list
	 * @secure
	 */
	permissionListList = (params: RequestParams = {}) =>
		this.request<String[], void>({
			path: `/role/permission/list`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Роли
	 * @summary Редактирование права доступа
	 * @request PUT:/role/permission/{id}
	 * @secure
	 */
	permissionUpdate = (id: string, data: PermissionCreateRequest, params: RequestParams = {}) =>
		this.request<RoleResponse, void | String[]>({
			path: `/role/permission/${id}`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Роли
	 * @summary Удаление права доступа
	 * @request DELETE:/role/permission/{id}
	 * @secure
	 */
	permissionDelete = (id: string, params: RequestParams = {}) =>
		this.request<RoleResponse, void>({
			path: `/role/permission/${id}`,
			method: "DELETE",
			secure: true,
			format: "json",
			...params,
		});
}
export const roleAPI = new Role();
